import backofficeService from "@/api/backoffice";

export default {
  getAll(params = {}) {
    return backofficeService.Api().get("inboundDelivery", { params })
      .then((response) => response.data);
  },
  getById(id) {
    return backofficeService.Api().get(`inboundDelivery/${id}`)
      .then((response) => response.data);
  },
};
